<body>
  <div class="mrf-filter__title">
    <span class="mrf-filter__title-text">{{ dialogTitle }}</span>
    <span class="mrf-filter__close" (click)="close()">X</span>
  </div>

  <ng-container *ngIf="isDefaultMode">
    <div class="mrf-filter__field">
      <label>Los</label>
      <mat-select
        class="mrf-filter__select"
        placeholder="Select"
        [(ngModel)]="selectedLos"
        [compareWith]="compareLosValues"
        (ngModelChange)="onLosChange($event)"
      >
        <input matInput [matAutocomplete]="losAuto" [formControl]="losFilter"
          class="mrf-filter__search" placeholder="Enter Los Name" />
        <mat-autocomplete #losAuto="matAutocomplete"></mat-autocomplete>
        <mat-option *ngFor="let item of losOptions | async" [value]="item">
          {{ item.name ?? item.location ?? item.los ?? item.losName }}
        </mat-option>
      </mat-select>
    </div>

    <div class="mrf-filter__field">
      <label>State</label>
      <mat-select
        class="mrf-filter__select"
        placeholder="Select"
        [(ngModel)]="selectedState"
        [compareWith]="compareStateValues"
        (ngModelChange)="onDefaultStateChange($event)"
      >
        <input matInput [matAutocomplete]="customStateAuto" [formControl]="stateFilter"
          class="mrf-filter__search" placeholder="Enter State Name" />
        <mat-autocomplete #customStateAuto="matAutocomplete"></mat-autocomplete>
        <mat-option *ngFor="let item of stateOptions | async" [value]="item">
          {{ item.name ?? item.stateName }}
        </mat-option>
      </mat-select>
    </div>

    <div class="mrf-filter__field">
      <label>City</label>
      <mat-select
        class="mrf-filter__select"
        placeholder="Select"
        [(ngModel)]="selectedCity"
        [compareWith]="compareCityValues"
        (ngModelChange)="onDefaultCityChange($event)"
      >
        <input matInput [matAutocomplete]="customCityAuto" [formControl]="cityFilter"
          class="mrf-filter__search" placeholder="Enter City Name" />
        <mat-autocomplete #customCityAuto="matAutocomplete"></mat-autocomplete>
        <mat-option *ngFor="let item of cityOptions | async" [value]="item">
          {{ item.name ?? item.cityName }}
        </mat-option>
      </mat-select>
    </div>

    <div class="mrf-filter__field">
      <label>Zone</label>
      <mat-select
        class="mrf-filter__select"
        placeholder="Select"
        [(ngModel)]="selectedZone"
        [compareWith]="compareZoneValues"
        (ngModelChange)="onDefaultZoneChange($event)"
      >
        <input matInput [matAutocomplete]="customZoneAuto" [formControl]="zoneFilter"
          class="mrf-filter__search" placeholder="Enter Zone Name" />
        <mat-autocomplete #customZoneAuto="matAutocomplete"></mat-autocomplete>
        <mat-option *ngFor="let item of zoneOptions | async" [value]="item">
          {{ item.zoneName }}
        </mat-option>
      </mat-select>
    </div>

    <div class="mrf-filter__field">
      <label>Sub Zone</label>
      <mat-select
        class="mrf-filter__select"
        placeholder="Select"
        [(ngModel)]="selectedSubZone"
        [compareWith]="compareSubZoneValues"
        (ngModelChange)="onSubZoneChange($event)"
      >
        <input matInput [matAutocomplete]="subZoneAuto" [formControl]="subZoneFilter"
          class="mrf-filter__search" placeholder="Enter Sub Zone Name" />
        <mat-autocomplete #subZoneAuto="matAutocomplete"></mat-autocomplete>
        <mat-option *ngFor="let item of subZoneOptions | async" [value]="item">
          {{ item.name ?? item.subZone ?? item.subZoneName }}
        </mat-option>
      </mat-select>
    </div>

    <div class="mrf-filter__field">
      <label>Dean Name</label>
      <mat-select
        class="mrf-filter__select"
        placeholder="Select"
        [(ngModel)]="selectedDean"
        [compareWith]="compareDeanValues"
        (ngModelChange)="onDeanChange($event)"
      >
        <input matInput [matAutocomplete]="deanAuto" [formControl]="deanFilter"
          class="mrf-filter__search" placeholder="Enter Dean Name" />
        <mat-autocomplete #deanAuto="matAutocomplete"></mat-autocomplete>
        <mat-option *ngFor="let item of deanOptions | async" [value]="item">
          {{ item.name ?? item.deanName ?? item.principalDeanName }}
        </mat-option>
      </mat-select>
    </div>

    <div class="mrf-filter__field">
      <label>Campus</label>
      <mat-select
        class="mrf-filter__select"
        placeholder="Select"
        [(ngModel)]="selectedCampus"
        [compareWith]="compareCampusValues"
        (ngModelChange)="onCampusChange($event)"
      >
        <input matInput [matAutocomplete]="customCampusAuto" [formControl]="campusFilter"
          class="mrf-filter__search" placeholder="Enter Campus Name" />
        <mat-autocomplete #customCampusAuto="matAutocomplete"></mat-autocomplete>
        <mat-option *ngFor="let item of campusOptions | async" [value]="item">
          {{ item.name ?? item.campusName }}
        </mat-option>
      </mat-select>
    </div>
  </ng-container>

  <ng-container *ngIf="isCustomizeMode">
    <div class="mrf-filter__customize-list">
      <div class="mrf-filter__customize-row" *ngFor="let row of customizeRows; let last = last">
        <label class="mrf-filter__customize-label">Filter By</label>
        <label class="mrf-filter__customize-label">Value</label>
        <span class="mrf-filter__customize-label mrf-filter__customize-label--actions" aria-hidden="true"></span>

        <div class="mrf-filter__customize-control">
          <mat-select
            class="mrf-filter__select mrf-filter__select--compact"
            placeholder="Select"
            [ngModel]="row.filterBy"
            (ngModelChange)="onCustomizeFilterByChange(row, $event)"
          >
            <mat-option [value]="null">Select</mat-option>
            <mat-option
              *ngFor="let option of getAvailableFilterByOptions(row)"
              [value]="option.value"
            >
              {{ option.label }}
            </mat-option>
          </mat-select>
        </div>

        <div class="mrf-filter__customize-control">
          <mat-select
            class="mrf-filter__select mrf-filter__select--compact"
            placeholder="Select"
            [disabled]="!row.filterBy || row.loading"
            [ngModel]="row.selectedValue"
            [compareWith]="compareCustomizeValues"
            (ngModelChange)="onCustomizeValueChange(row, $event)"
          >
            <input
              matInput
              [formControl]="row.searchControl"
              class="mrf-filter__search"
              [placeholder]="row.loading ? 'Loading...' : 'Search'"
              [disabled]="!row.filterBy || row.loading"
            />
            <mat-option
              *ngFor="let item of row.filteredOptions$ | async"
              [value]="item"
            >
              {{ getCustomizeOptionLabel(row.filterBy, item) }}
            </mat-option>
          </mat-select>
        </div>

        <div class="mrf-filter__customize-action-btns">
          <button
            type="button"
            class="mrf-filter__icon-btn mrf-filter__icon-btn--remove"
            *ngIf="customizeRows.length > 1"
            (click)="removeCustomizeRow(row.id)"
            aria-label="Remove filter row"
          >
            -
          </button>
          <button
            type="button"
            class="mrf-filter__icon-btn mrf-filter__icon-btn--add"
            *ngIf="last"
            [disabled]="!canAddCustomizeRow(row)"
            (click)="addCustomizeRow(row)"
            aria-label="Add filter row"
          >
            +
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="mrf-filter__actions">
    <ng-container *ngIf="isCustomizeMode">
      <button type="button" class="mrf-filter__secondary-btn" (click)="clearCustomizeFilters()">
        Clear
      </button>
      <button type="button" class="mrf-filter__secondary-btn" (click)="resetCustomizeFilters()">
        Reset
      </button>
    </ng-container>
    <button type="button" class="mrf-filter__search-btn" (click)="search()">Search</button>
  </div>
</body>
